import ObjectUtil from "../../../../core/internal/util/ObjectUtil"

import { InAppMessagePresentationContext } from "../../present/presentation/InAppMessagePresentationContext"
import { InAppMessageHtmlContentFetcher } from "./InAppMessageHtmlContentFetcher"

export class InAppMessageHtmlContentResolver {
  constructor(private readonly htmlFetcher: InAppMessageHtmlContentFetcher) {}

  async resolve(context: InAppMessagePresentationContext): Promise<string> {
    const html = ObjectUtil.requiredNotNullOrUndefined(
      context.message.html,
      () => `HTML is not found in InAppMessagePresentationContext [${context.inAppMessage.key}]`
    )

    try {
      switch (html.resourceType) {
        case "TEXT":
          return html.text
        case "PATH":
          return await this.htmlFetcher.fetchHtmlContent(html.path)
        default:
          throw new Error(`Unsupported HTML resource type: ${(html as any)?.resourceType}`)
      }
    } catch (err) {
      throw new Error(`Failed to get HTML for InAppMessage [${context.inAppMessage.key}]: ${err}`)
    }
  }
}
